import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'

import { baseUrl } from '@/constants'
import { RootState } from '@/store'
import { logout } from '@/store/accountSlice'
import { getToken, shouldRefresh } from '@/utils'

const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const fromState = (getState() as RootState).account.token
    const fromStorage = getToken()
    const token = fromState || fromStorage
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const baseQueryFn: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await baseQuery(args, api, extraOptions)
  if (result.error && shouldRefresh(result.error)) {
    api.dispatch(logout())
  }
  return result
}

export const tagTypes = [
  'Tags',
  'Home',
  'User',
  'Subjects',
  'Classroom',
  'Teaching',
  'Content',
  'Exercise',
  'Delivery',
  'Grades',
  'Evaluations',
  'Absences',
  'Dreamshaper',
  'Message',
  'Group',
  'Alerts',
  'Feedbacks',
  'Attendances',
  'Extensions',
  'Attachments',
  'AbsencesMed',
  'ExerciseQuestions',
  'ExerciseQuestion',
  'ExerciseProofs',
  'NewGrades',
  'TeachingSectionQuestions',
  'ClassroomQuestionProgress',
  'TechTracks',
  'InstitutionalAssessments',
  'Banners',
  'Teaching',
  'TeachingSectionQuestions',
  'ClassroomQuestionProgress',
  'ClassroomSubject',
  'ClassroomSubjectDescription',
  'ClassroomSubjectStudyPlan',
  'ClassroomSubjectItem',
] as const

const baseApi = createApi({
  baseQuery: baseQueryFn,
  tagTypes,
  endpoints: () => ({}),
})

export default baseApi
